import { Button, Col, Select } from 'antd';
import { isEmpty } from 'underscore';
import { DownloadInfoItem } from '../../../../../../types/analytics';
import { Label } from '../../../../../common/Label/Label';
import styles from '../../../Style/DatasetInfo.module.scss';

interface ModelDataSelectorProps {
  id: string;
  item: DownloadInfoItem;
  datasetId: string;
  options: Array<{ id: string; value: string }>;
  onShowMetadata: (datasetId: string, fn: (id: string) => void) => void;
  onDatasetChange: (value: string) => void;
  isDisabled: boolean;
  onChange: (id: string) => void;
  testId: string;
}

export const ModelDataSelector = ({
  datasetId,
  id,
  options,
  onShowMetadata,
  onDatasetChange,
  isDisabled,
  onChange,
  testId,
}: ModelDataSelectorProps) => {
  return (
    <Col span={12}>
      <Label
        label={
          <div className={styles.DatasetMetadata}>
            <div>
              <b>Model Data</b>
            </div>
            <Button
              className={styles.buttonBorder}
              type='default'
              onClick={() => onShowMetadata(datasetId, onChange)}
            >
              <div className={styles.buttonContent}>
                <div className={styles.buttonLabel}>Metadata</div>
              </div>
            </Button>
          </div>
        }
      >
        <Select
          id={id}
          data-testid={testId}
          value={datasetId}
          className={styles.InfoSelect}
          onChange={onDatasetChange}
          disabled={isEmpty(datasetId) || isDisabled}
        >
          {options &&
            options.map((option) => (
              <Select.Option key={option.id} value={option.id}>
                {option.value}
              </Select.Option>
            ))}
        </Select>
      </Label>
    </Col>
  );
};
